/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_ViewInputs */

const en_story_view = /** @type {(inputs: Story_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const es_story_view = /** @type {(inputs: Story_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const fr_story_view = /** @type {(inputs: Story_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir`)
};

const de_story_view = /** @type {(inputs: Story_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansehen`)
};

const id_story_view = /** @type {(inputs: Story_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat`)
};

/** @type {(inputs: Story_ViewInputs) => LocalizedString} */
const ja_story_view = en_story_view;

/** @type {(inputs: Story_ViewInputs) => LocalizedString} */
const zh_story_view = en_story_view;

/** @type {(inputs: Story_ViewInputs) => LocalizedString} */
const ar_story_view = en_story_view;

/** @type {(inputs: Story_ViewInputs) => LocalizedString} */
const it_story_view = en_story_view;

/** @type {(inputs: Story_ViewInputs) => LocalizedString} */
const ru_story_view = en_story_view;

/** @type {(inputs: Story_ViewInputs) => LocalizedString} */
const pt_story_view = en_story_view;

/** @type {(inputs: Story_ViewInputs) => LocalizedString} */
const ko_story_view = en_story_view;

/**
* | output |
* | --- |
* | "View" |
*
* @param {Story_ViewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_view = /** @type {((inputs?: Story_ViewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_ViewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_view(inputs)
	if (locale === "es") return es_story_view(inputs)
	if (locale === "fr") return fr_story_view(inputs)
	if (locale === "de") return de_story_view(inputs)
	if (locale === "ja") return ja_story_view(inputs)
	if (locale === "zh") return zh_story_view(inputs)
	if (locale === "ar") return ar_story_view(inputs)
	if (locale === "id") return id_story_view(inputs)
	if (locale === "it") return it_story_view(inputs)
	if (locale === "ru") return ru_story_view(inputs)
	if (locale === "pt") return pt_story_view(inputs)
	return ko_story_view(inputs)
});